import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogActions, DialogTitle, DialogContent } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import BoardInfoLaneDescription from '../../../components/BoardInfo/BoardInfoLaneDescription'
import localize from '../../../higherOrderComponents/localize'

export const BoardInfoDialog = props => {
  const name = props.boardDef ? props.boardDef.name : ''
  const swimlanes = props.boardDef ? props.boardDef.swimlanes : []
  const open = !!props.open
  return (
    <Dialog
      modal={false}
      open={open}
      onClose={props.closeAction}
      autoScrollBodyContent
      maxWidth='md'
      >
      <DialogTitle>{name}</DialogTitle>
      <DialogContent>
        <div className='board-info--header-container'>
          <div className='board-info--lane-name-header'>{localize('taskBoards.Label_LaneName')}</div>
          <div className='board-info--lane-description-header'>{localize('common.Label_Description')}</div>
        </div>
        <div className='board-info--lanes-container'>
          {swimlanes.map((lane) => {
            return (
              <BoardInfoLaneDescription
                localize={props.localize}
                key={lane.id}
                name={lane.name}
                mapping={lane.mapping} />
            )
          })}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          color='primary'
          onClick={props.closeAction}
        >Close</Button>
      </DialogActions>
    </Dialog>
  )
}

BoardInfoDialog.propTypes = {
  closeAction: PropTypes.func.isRequired,
  boardDef: PropTypes.object,
  open: PropTypes.bool,
  localize: PropTypes.func
}

export default localize(BoardInfoDialog)



// WEBPACK FOOTER //
// ./src/routes/BoardDefsEditor/components/BoardInfoDialog.js